<template>
	<div>
		<div class="mb-4">
			<button
				v-for="(item) in options"
				:key="item"
				type="button"
				class="btn btn-outline-primary mr-2"
				@click="donationAmount = parseInt(item)"
			>
				{{ Number(item).toLocaleString() }} ₽
			</button>
		</div>

		<FormulateInput
			v-model="donationAmount"
			name="donation_amount"
			label="Другая сумма поддержки"
			placeholder="Введите значение в рублях"
			type="number"
			validation="bail|required|max:1000000"
			:validation-messages="{
				required: 'Введите значение в рублях',
				max: 'Максимальное допустимая сумма - 1 млн. рублей',
			}"
		/>
	</div>
</template>

<script>
export default {
	name: 'CustomDonationAmountInput',
	props: {
		options: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			donationAmount: null,
		};
	},
};
</script>

<style lang="scss" scoped>

</style>
